import * as React from 'react';

const SvgIconCheckCircleFilled = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em" }, props),
    React.createElement("path", { d: "M12 0c6.617 0 12 5.383 12 12s-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0Zm5.65 8.24a1 1 0 0 0-1.41.11l-5.296 6.18-2.237-2.237a1 1 0 1 0-1.414 1.414l3 3a1 1 0 0 0 1.466-.056l6-7a1 1 0 0 0-.108-1.41Z", fill: "#222", fillRule: "evenodd", className: "fi-icon-base-fill" })));

export { SvgIconCheckCircleFilled as default };
//# sourceMappingURL=IconCheckCircleFilled.js.map
